import { useRef } from "react";

// Controls loading presentation only. The caller still enforces every returned
// restriction/error, and the server continues to authorize every operation.
export default function useInitialAccountCheck({
  userId,
  authLoading,
  suspensionLoading,
  warningLoading,
  suspensionError,
  warningError,
}) {
  const verifiedUser = useRef(null);
  if (!userId || (verifiedUser.current && verifiedUser.current !== userId))
    verifiedUser.current = null;
  if (
    userId &&
    !authLoading &&
    !suspensionLoading &&
    !warningLoading &&
    !suspensionError &&
    !warningError
  )
    verifiedUser.current = userId;
  return Boolean(
    userId &&
    !authLoading &&
    (suspensionLoading || warningLoading) &&
    verifiedUser.current !== userId,
  );
}
